module.exports = __webpack_public_path__ + "img/icon_def_image.ed76370b.svg";